<script setup>
import { computed, defineProps, } from 'vue'

const props = defineProps({
  isSelected: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const getStateStyling = computed(() => {
  if (props.isSelected && !props.disabled) {
    return 'bg-surface-active text-accent border border-primary dark:text-neutral cursor-pointer'
  }
  if (props.isSelected && props.disabled) {
    return 'bg-surface-primary text-accent opacity-45'
  }

  if (props.disabled) {
    return 'bg-surface-primary text-neutral opacity-45'
  }

  return 'bg-surface-primary text-accent hover:border border-primary cursor-pointer dark:text-neutral'
})
</script>

<template>
  <div
      class="flex items-center justify-center w-14 h-20 text-center text-2xl font-bold align-middle rounded-lg"
      :class="getStateStyling">
    <slot></slot>
  </div>
</template>
